import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CommonHttpService } from 'src/app/utils/common-http.service';
import { AuthenticationService } from '../../../../../utils/authentication.service';
import { LocalStorageService } from '../..//../../../utils/local-storage.service';
import constant from 'src/app/app.constant';
import { HeaderService } from 'src/app/service/header.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UploadImageService } from 'src/app/service/uploadImage';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import commonLogics from '../../../../../utils/common-logic.service';
import { GeocodeAutoCompleteComponent } from 'src/app/components/google/geocode-auto-complete/geocode-auto-complete.component';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent implements OnInit {
  firstFormGroup: FormGroup;
  userDetails: any = {};
  dp_url: string;
  logo_url: string;
  icon_url: string;
  changelogoIconUrl: boolean = false;
  public commonLogics: any = commonLogics;
  public constant: any = constant;
  oldDateFormat: any;
  oldCurrencyFormat: any;
  whiteLabel: boolean;
  readonlyField: boolean = false;
  submitted: boolean = false;

  // modalRefGeocodeGoogleAutoCompleteModel: NgbModalRef;
  constructor(private imageUpload: UploadImageService, public authService: AuthenticationService, public headerService: HeaderService, private _formBuilder: FormBuilder,
    private toaster: ToastrService, public localStorageservice: LocalStorageService, private http: CommonHttpService, private modalService: NgbModal) {

    this.headerService.userDetails.subscribe((user) => {
      this.userDetails = user;
    });
    setTimeout(() => {
      this.whiteLabel = this.localStorageservice.getItem(constant.localStorage.white_label);
      let newDate = moment().format('x');
      this.headerService.userDetails.next({
        name: this.localStorageservice.getItem(constant.localStorage.user_name),
        role_name: this.localStorageservice.getItem(constant.localStorage.role_name),
        fixed_price: this.localStorageservice.getItem(constant.localStorage.fixed_price),
        // dp_url: constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + this.localStorageservice.getItem(constant.localStorage.dp_url) + '&=' + newDate
      });
      // this.logo_url = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + this.localStorageservice.getItem(constant.localStorage.logo_url) + '&=' + newDate;
      // this.icon_url = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + this.localStorageservice.getItem(constant.localStorage.icon_url) + '&=' + newDate;
      this.dp_url = this.userDetails.dp_url;
      this.oldDateFormat = this.localStorageservice.getItem(constant.localStorage.date_time_format);
      this.oldCurrencyFormat = this.localStorageservice.getItem(constant.localStorage.currency_symbol);
    }, 3000);

    setTimeout(() => {
      this.firstFormGroup = this._formBuilder.group({
        first_name: [this.localStorageservice.getItem(constant.localStorage.first_name), Validators.required],
        last_name: [this.localStorageservice.getItem(constant.localStorage.last_name)],
        dp_url: [this.localStorageservice.getItem(constant.localStorage.dp_url)],
        logo_url: [this.localStorageservice.getItem(constant.localStorage.logo_url)],
        icon_url: [this.localStorageservice.getItem(constant.localStorage.icon_url)],
        email: [this.localStorageservice.getItem(constant.localStorage.email)],
        phone: [this.localStorageservice.getItem(constant.localStorage.phone), Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")],
        min_km: [this.localStorageservice.getItem(constant.localStorage.min_km), Validators.required],
        min_km_price: [this.localStorageservice.getItem(constant.localStorage.min_km_price), Validators.required],
        price_per_km: [this.localStorageservice.getItem(constant.localStorage.price_per_km), Validators.required],
        date_time_format: [this.localStorageservice.getItem(constant.localStorage.date_time_format)],
        currency_symbol: [this.localStorageservice.getItem(constant.localStorage.currency_symbol)],
        disable_rider_price_in_app: [this.localStorageservice.getItem(constant.localStorage.disable_rider_price_in_app)],
        address: [this.localStorageservice.getItem(constant.localStorage.address)]
      });
      this.readonlyField = (this.userDetails?.fixed_price) ? this.userDetails?.fixed_price : false;
    }, 1500)

  }

  ngOnInit() {
  }
  openAccount(content) {
    this.modalService.open(content, { centered: true });
  }
  ngOnDestroy() {
    this.headerService.userDetails.unsubscribe();
  }
  userUpdate(value: any) {
    this.submitted = true;
    if (this.firstFormGroup.valid) {
      this.submitted = false;
      let reqJson: any = { ...this.firstFormGroup.value }
      delete reqJson.address;
      reqJson.user_id = this.localStorageservice.getItem(constant.localStorage.user_id);
      if (['assets/images/logo/logo-icon.png'].includes(reqJson.icon_url)) {
        reqJson.icon_url = null;
      }
      if (['assets/images/logo/logo.png'].includes(reqJson.logo_url)) {
        reqJson.logo_url = null;
      }
      if (['assets/images/user/user.png'].includes(reqJson.dp_url)) {
        reqJson.dp_url = null;
      }
      this.http.updateData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.User.DesktopUpdateToken, reqJson).subscribe((response: any) => {
        if (response.status) {
          var first_name = this.firstFormGroup.get('first_name').value
          var last_name = this.firstFormGroup.get('last_name').value
          if (!_.isEmpty(first_name)) {
            if (!_.isEmpty(last_name)) {
              var full_name = first_name.concat(last_name.toString());
              this.localStorageservice.addItem(constant.localStorage.user_name, full_name);
            } else {
              this.localStorageservice.addItem(constant.localStorage.user_name, first_name);
            }
          } else {
            if (!_.isEmpty(last_name)) {
              this.localStorageservice.addItem(constant.localStorage.user_name, last_name);
            }
          }
          var dp_url = this.firstFormGroup.get('dp_url').value
          this.localStorageservice.addItem(constant.localStorage.dp_url, dp_url);
          let newDate = moment().format('x');
          this.localStorageservice.addItem(constant.localStorage.last_name, this.firstFormGroup.get('last_name').value);
          this.localStorageservice.addItem(constant.localStorage.first_name, this.firstFormGroup.get('first_name').value);
          this.localStorageservice.addItem(constant.localStorage.min_km, this.firstFormGroup.get('min_km').value);
          this.localStorageservice.addItem(constant.localStorage.min_km_price, this.firstFormGroup.get('min_km_price').value);
          this.localStorageservice.addItem(constant.localStorage.price_per_km, this.firstFormGroup.get('price_per_km').value);
          this.localStorageservice.addItem(constant.localStorage.date_time_format, this.firstFormGroup.get('date_time_format').value);
          this.localStorageservice.addItem(constant.localStorage.phone, this.firstFormGroup.get('phone').value);
          this.localStorageservice.addItem(constant.localStorage.currency_symbol, this.firstFormGroup.get('currency_symbol').value);
          this.localStorageservice.addItem(constant.localStorage.logo_url, this.firstFormGroup.value.logo_url);
          this.localStorageservice.addItem(constant.localStorage.icon_url, this.firstFormGroup.value.icon_url);
          this.localStorageservice.addItem(constant.localStorage.disable_rider_price_in_app, this.firstFormGroup.value.disable_rider_price_in_app);
          this.headerService.userDetails.next({
            name: this.localStorageservice.getItem(constant.localStorage.user_name),
            fixed_price: this.localStorageservice.getItem(constant.localStorage.fixed_price),
            role_name: this.localStorageservice.getItem(constant.localStorage.role_name),
            // dp_url: constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + this.localStorageservice.getItem(constant.localStorage.dp_url) + '&=' + newDate
          });
          // this.logo_url = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + this.localStorageservice.getItem(constant.localStorage.logo_url) + '&=' + newDate;
          // this.icon_url = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + this.localStorageservice.getItem(constant.localStorage.icon_url) + '&=' + newDate;

          this.modalService.dismissAll();
          var newDateFormat = this.firstFormGroup.get('date_time_format').value;
          var newCurrencyFormat = this.firstFormGroup.get('currency_symbol').value;
          this.toaster.success('Successfully Updated');
          if ((this.oldDateFormat != newDateFormat) || (this.oldCurrencyFormat != newCurrencyFormat || this.changelogoIconUrl)) {
            setTimeout(() => {
              window.location.reload();
            }, 1000)
          }
        } else {
          this.toaster.error(response.message);
        }
      });
    }
  }
  @ViewChild('myInput') myInputVariable: ElementRef;
  @ViewChild('mylogoIcon') mylogoIcon: ElementRef;
  @ViewChild('mylogo') mylogoUrl: ElementRef;
  //profile upload
  async uploadProfileImage(event: any) {
    var data: any = { img_for: 'user', img_type: 'profile', img_name: 'image', first_id: this.localStorageservice.getItem(constant.localStorage.user_id) }
    var maxSize = 1000000;
    // const max_height = 450;
    // const max_width = 600;
    // const reader = new FileReader();
    // reader.readAsDataURL(event.target.files[0]);
    // reader.onload = (e: any) => {
    //   const image = new Image();
    //   image.src = e.target.result;
    //   image.onload = async rs => {
    //     const img_height = rs.currentTarget['height'];
    //     const img_width = rs.currentTarget['width'];

    //     if (img_height > max_height && img_width > max_width) {
    //       var imageError =
    //         'Maximum dimentions allowed ' +
    //         max_height +
    //         '*' +
    //         max_width +
    //         'px';
    //       this.toaster.error(imageError);
    //       this.mylogoIcon.nativeElement.value = "";
    //     } else {
    const allowed_types = ['image/png', 'image/jpeg'];
    if (event.target.files[0]?.size < maxSize) {
      if (!_.includes(allowed_types, event.target.files[0].type)) {
        var imageError = 'Only Images are allowed ( JPG | PNG |JPEG )';
        return this.toaster.error(imageError)
      }
      var imageUrl: any = await this.imageUpload.imageUpload(event, data);
      if (!(imageUrl instanceof Error) && imageUrl.status) {
        let newDate = moment().format('x');
        // this.dp_url = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + imageUrl.data + '&=' + newDate;
        this.firstFormGroup.patchValue({
          dp_url: imageUrl.data
        })
      }
      this.changelogoIconUrl = true;

    } else {
      this.toaster.error('File should be less than 1MB')
      this.myInputVariable.nativeElement.value = "";
    }
    //     }
    //   }
    // }
  }
  //logo image
  async uploadLogoImage(event: any) {
    var data: any = { img_for: 'user', img_type: 'logo', img_name: 'logoImg', first_id: this.localStorageservice.getItem(constant.localStorage.user_id) }

    var maxSize = 1000000;
    // const max_height = 450;
    // const max_width = 600;
    // const reader = new FileReader();
    // reader.readAsDataURL(event.target.files[0]);
    // reader.onload = (e: any) => {
    //   const image = new Image();
    //   image.src = e.target.result;
    //   image.onload = async rs => {
    //     const img_height = rs.currentTarget['height'];
    //     const img_width = rs.currentTarget['width'];

    //     if (img_height > max_height && img_width > max_width) {
    //       var imageError =
    //         'Maximum dimentions allowed ' +
    //         max_height +
    //         '*' +
    //         max_width +
    //         'px';
    //       this.toaster.error(imageError);
    //       this.mylogoUrl.nativeElement.value = "";
    //     } else {
    const allowed_types = ['image/png', 'image/jpeg'];
    if (event.target.files[0]?.size < maxSize) {
      if (!_.includes(allowed_types, event.target.files[0].type)) {
        var imageError = 'Only Images are allowed ( JPG | PNG |JPEG )';
        return this.toaster.error(imageError)
      }

      var imageUrl: any = await this.imageUpload.imageUpload(event, data);
      if (!(imageUrl instanceof Error) && imageUrl.status) {
        let newDate = moment().format('x');
        // this.logo_url = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + imageUrl.data + '&=' + newDate;
        this.firstFormGroup.patchValue({
          logo_url: imageUrl.data
        })
      }
      this.changelogoIconUrl = true;

    } else {
      this.toaster.error('File should be less than 1MB')
      this.mylogoUrl.nativeElement.value = "";
    }
    //     }
    //   }
    // }
  }


  //icon image
  async uploadIconImage(event: any) {
    var data: any = { img_for: 'user', img_type: 'logoIcon', img_name: 'iconImg', first_id: this.localStorageservice.getItem(constant.localStorage.user_id) }
    var maxSize = 1000000;
    // const max_height = 450;
    // const max_width = 600;
    // const reader = new FileReader();
    // reader.readAsDataURL(event.target.files[0]);
    // reader.onload = (e: any) => {
    //   const image = new Image();
    //   image.src = e.target.result;
    //   image.onload = async rs => {
    //     const img_height = rs.currentTarget['height'];
    //     const img_width = rs.currentTarget['width'];

    //     if (img_height > max_height && img_width > max_width) {
    //       var imageError =
    //         'Maximum dimentions allowed ' +
    //         max_height +
    //         '*' +
    //         max_width +
    //         'px';
    //       this.toaster.error(imageError);
    //       this.mylogoIcon.nativeElement.value = "";
    //     } else {
    const allowed_types = ['image/png', 'image/jpeg'];
    if (event.target.files[0]?.size < maxSize) {
      if (!_.includes(allowed_types, event.target.files[0].type)) {
        var imageError = 'Only Images are allowed ( JPG | PNG |JPEG )';
        return this.toaster.error(imageError)
      }
      var imageUrl: any = await this.imageUpload.imageUpload(event, data);
      if (!(imageUrl instanceof Error) && imageUrl.status) {
        let newDate = moment().format('x');
        // this.icon_url = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + imageUrl.data + '&=' + newDate;
        this.firstFormGroup.patchValue({
          icon_url: imageUrl.data
        })
      }
      this.changelogoIconUrl = true;
    } else {
      this.toaster.error('File should be less than 1MB')
      this.mylogoIcon.nativeElement.value = "";
    }
  }
  geocodeGoogleAutoCompleteModel() {
    const modalRefGeocodeGoogleAutoCompleteModel = this.modalService.open(GeocodeAutoCompleteComponent,
      {
        scrollable: true,
        windowClass: 'myCustomModalClass',
        size: 'lg'
        // keyboard: false,
        // backdrop: 'static'
      });
    var user: any;
    if (user) {
      let data = {
      }
      modalRefGeocodeGoogleAutoCompleteModel.componentInstance.addressData = data;

    }
    modalRefGeocodeGoogleAutoCompleteModel.result.then((result) => {
      // console.log("result", result)
    }, (reason) => {
      // console.log("reason", reason)
      this.firstFormGroup.patchValue({
        address: this.localStorageservice.getItem(constant.localStorage.address)
      })
    });
  }
}
